<template lang="pug">
  component.v-icon(
    v-if="currentName"
    :is="currentName"
    :class="`--${currentName}`"
    :size="size"
    :color="color"
  )
</template>

<script>
  import IconMixin from '@/mixins/icon';
  import { camelCase } from 'lodash';
  import book from './book';
  import bookOpen from './bookOpen';
  import calendar from './calendar';
  import chalkBoard from './chalkBoard';
  import coins from './coins';
  import graduationCap from './graduationCap';
  import logout from './logout';
  import poll from './poll';
  import envelop from './envelop';
  import users from './users';
  import chevronRight from './chevron-right';
  import arrow from './arrow';
  import download from './download';
  import filterIcon from './filterIcon';
  import close from './close';
  import edit from './edit';
  import eye from './eye';
  import eyeSlash from './eyeSlash';
  import fileLines from './fileLines';

  export default {
    components: {
      graduationCap,
      chevronRight,
      chalkBoard,
      filterIcon,
      calendar,
      download,
      bookOpen,
      envelop,
      logout,
      arrow,
      coins,
      close,
      users,
      poll,
      book,
      edit,
      eye,
      eyeSlash,
      fileLines
    },
    mixins: [IconMixin],
    props: {
      name: {
        type: String,
        default: ''
      },
    },

    computed: {
      currentName() {
        return this.$options.components[camelCase(this.name)] ? camelCase(this.name) : null
      }
    }
  }
</script>
